import {
  FC,
  ReactNode,
  useCallback,
  useState,
  MouseEvent,
  createContext,
  useContext,
  SyntheticEvent,
} from 'react';

import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';

type Props = IconButtonProps & {
  icon: ReactNode;
};

type MenuContextType = {
  close: () => void;
};

const MenuContext = createContext<MenuContextType>({
  close: () => {},
});

export const useMenu = () => useContext(MenuContext);

const IconButtonMenu: FC<Props> = ({ icon, children, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    setAnchorEl(event.currentTarget);
  }, []);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleCloseClick = useCallback(
    (event: SyntheticEvent) => {
      event.stopPropagation();

      close();
    },
    [close]
  );

  return (
    <MenuContext.Provider value={{ close }}>
      <IconButton {...rest} onClick={handleClick}>
        {icon}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseClick}>
        {children}
      </Menu>
    </MenuContext.Provider>
  );
};

export default IconButtonMenu;
